import ExploreIcon from '@mui/icons-material/Explore';
import FlightIcon from '@mui/icons-material/Flight';
import HeightIcon from '@mui/icons-material/Height';
import PlaceIcon from '@mui/icons-material/Place';
import ScheduleIcon from '@mui/icons-material/Schedule';
import SpeedIcon from '@mui/icons-material/Speed';
import { Box, Grid, Typography } from '@mui/material';
import { convertMetersToFeetAltitude, convertMetersToFeetSpeed, Display, formatLatitude, formatLongitude, GeoInformation } from 'adoms-common-lib';
import React from 'react';
import { Popup } from 'react-map-gl';

type DronePopupProps = {
    dronePopupInfo: GeoInformation
    setDronePopupInfo: (value: React.SetStateAction<GeoInformation | undefined>) => void
}

/**
 * ポート情報を表示するポップアップ
 * @param props 
 * @returns 
 */
export const DronePopup: React.FC<DronePopupProps> = (props) => {
    const displayPosition = () => {
        const decimalLatitude = props.dronePopupInfo.latitude;
        const decimalLongitude = props.dronePopupInfo.longitude;
        const sexagesimalLatitude = formatLatitude(decimalLatitude);
        const sexagesimalLongitude = formatLongitude(decimalLongitude);

        return (
            <Grid item container xs zeroMinWidth wrap="nowrap" >
                <PlaceIcon fontSize="small" sx={{ marginRight: "2px" }} />
                <Box>
                    <Typography variant='subtitle2'>
                        {decimalLatitude + "," + decimalLongitude}
                    </Typography>
                    <Typography variant='subtitle2'>
                        {sexagesimalLatitude + "," + sexagesimalLongitude}
                    </Typography>
                </Box>
            </Grid>
        )

    };

    const displayAltitude = (altitude?: number) => {
        if (altitude === undefined || altitude === null) {
            return "ー";
        }
        const feet = convertMetersToFeetAltitude(altitude);
        return `${altitude} m / ${feet} ft`;
    };

    const displayHeading = (heading?: number) => {
        if (heading === undefined || heading === null) {
            return "ー";
        }
        return `${heading}°`;
    };

    const displaySpeed = (speed?: number) => {
        if (speed === undefined || speed === null) {
            return "ー";
        }
        const speedKt = convertMetersToFeetSpeed(speed);
        return `${speed} m/s / ${speedKt} kt`;
    };

    return (
        <Popup
            longitude={props.dronePopupInfo.longitude}
            latitude={props.dronePopupInfo.latitude}
            anchor="bottom"
            onClose={() => props.setDronePopupInfo(undefined)}
            style={{ zIndex: 301 }}>
            <Grid container spacing={1} direction={"column"}>
                <Grid item container direction="row" xs>
                    <FlightIcon fontSize="small" sx={{ marginRight: "2px" }} />
                    <Typography variant='subtitle2'>
                        {props.dronePopupInfo.flightId}
                    </Typography>
                </Grid>
                <Grid item container direction="row" xs>
                    <ScheduleIcon fontSize="small" sx={{ marginRight: "2px" }} />
                    <Typography variant='subtitle2'>
                        {Display.getTimeMiniteSecondStringFromISO8601(props.dronePopupInfo.sendTime)}
                    </Typography>
                </Grid>
                {displayPosition()}
                <Grid item container direction="row" xs>
                    <HeightIcon fontSize="small" sx={{ marginRight: "2px" }} />
                    <Typography variant='subtitle2'>
                        {displayAltitude(props.dronePopupInfo.altitude)}
                    </Typography>
                </Grid>
                <Grid item container direction="row" xs>
                    <ExploreIcon fontSize="small" sx={{ marginRight: "2px" }} />
                    <Typography variant='subtitle2'>
                        {displayHeading(props.dronePopupInfo.heading)}
                    </Typography>
                </Grid>
                <Grid item container direction="row" xs>
                    <SpeedIcon fontSize="small" sx={{ marginRight: "2px" }} />
                    <Typography variant='subtitle2'>
                        {displaySpeed(props.dronePopupInfo.speed)}
                    </Typography>
                </Grid>
            </Grid>
        </Popup>
    )
}